import script from "./other.vue?vue&type=script&setup=true&lang=js"
export * from "./other.vue?vue&type=script&setup=true&lang=js"

import "./other.vue?vue&type=style&index=0&id=23b3b16a&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23b3b16a"]])

export default __exports__